import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposizione-di-terzo-view',
  templateUrl: './form-opposizione-di-terzo-view.component.html',
  styleUrls: ['./form-opposizione-di-terzo-view.component.css']
})
export class FormOpposizioneDiTerzoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
